// extracted by mini-css-extract-plugin
export default {"saleRow":"qLa0R","borderTop":"EhbSD","icon":"Mk4nS","text":"Ab9RF","inherit":"ZfWET","center":"RRL6z","transformer":"GB0k1","injection":"nQO6s"};